import api from './api';

const userService = {
  // Get paginated list of users
  getUsers: async (page = 0, size = 10) => {
    return api.get(`/api/admin/users?page=${page}&size=${size}`);
  },

  // Get a single user by ID
  getUser: async (userId) => {
    return api.get(`/api/admin/users/${userId}`);
  },

  // Create a new user
  createUser: async (userData) => {
    return api.post('/api/admin/users', userData);
  },

  // Update an existing user
  updateUser: async (userId, userData) => {
    return api.put(`/api/admin/users/${userId}`, userData);
  },

  // Update user password
  updatePassword: async (userId, newPassword) => {
    return api.patch(`/api/admin/users/${userId}/password`, { newPassword });
  },

  // Delete a user
  deleteUser: async (userId) => {
    return api.delete(`/api/admin/users/${userId}`);
  },

  // Search users with filters
  searchUsers: async (searchParams, page = 0, size = 20) => {
    return api.post(`/api/admin/users/search?page=${page}&size=${size}`, searchParams);
  },

  // Get user statistics
  getStats: async () => {
    return api.get('/api/admin/users/stats');
  },

  // Get sync status (SUPER_ADMIN only)
  getSyncStatus: async () => {
    return api.get('/api/admin/sync/status');
  },

  // Get revoked token count for a user (SUPER_ADMIN only)
  getRevokedTokenCount: async (userId) => {
    return api.post(`/api/admin/tokens/revoke-user/${userId}`);
  },

  // Manual token cleanup (SUPER_ADMIN only)
  cleanupExpiredTokens: async () => {
    return api.delete('/api/admin/tokens/cleanup');
  },
};

export default userService;
